import type { Dictionary } from '@types'

export const BENEFITS_CAPTIONS = {
  HEALTH_INSURANCE: 'Health Insurance',
  RETIREMENT_PLAN: 'Retirement Plan',
  PAID_TIME_OFF: 'Paid Time Off',
  LIFE_INSURANCE: 'Life Insurance',
  DISABILITY_INSURANCE: 'Disability Insurance',
  TUITION_REIMBURSEMENT: 'Tuition Reimbursement',
  EMPLOYEE_ASSISTANCE: 'Employee Assistance',
  FLEXIBLE_SPENDING_ACCOUNT: 'Flexible Spending Account',
  EMPLOYEE_DISCOUNTS: 'Employee Discounts',
  WELLNESS_PROGRAM: 'Wellness Program',
  SIGN_ON_BONUS: 'Sign On Bonus',
}

export const EXPERIMENT_COOKIES_DEFAULT_OPTIONS = {
  maxAge: 24 * 60 * 60,
  path: '/',
  secure: true,
}

export const GOOGLE_CRAWLERS: string[] = [
  'Mozilla/5.0 (Windows NT 5.1; rv:11.0) Gecko Firefox/11.0 (via ggpht.com GoogleImageProxy)',
  'Mozilla/5.0 (compatible; Googlebot/2.1; +http://www.google.com/bot.html)',
  'Googlebot-Image/1.0',
  'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/56.0.2924.87 Safari/537.36 Google (+https://developers.google.com/+/web/snippet/)',
  'Mozilla/5.0 (Linux; Android 6.0.1; Nexus 5X Build/MMB29P) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/41.0.2272.96 Mobile Safari/537.36 (compatible; Googlebot/2.1; +http://www.google.com/bot.html)',
  'Googlebot/2.1 (+http://www.google.com/bot.html)',
]

// Shorter than the page's `revalidate = 3600` on purpose, for two reasons. The working set scales
// with this window: ~70 MB here against ~800 MB at 3600s, on a Valkey shared with the ISR page
// cache. And the two caches compose — an entry this old can be the data a fresh ISR render is
// built from — so worst-case staleness is 3600s plus this TTL: 3900s at 300s, and it would have
// been 7200s at 3600s. The fan-out fix is the request memo, not this TTL [S20-770].
export const JOB_PAGE_CACHE_TTL_SECONDS = 300

export const basePath =
  process.env.NEXT_PUBLIC_BASE_PATH === '/' || process.env.NEXT_PUBLIC_BASE_PATH === null
    ? ''
    : (process.env.NEXT_PUBLIC_BASE_PATH as string).replace(/\/+$/, '')

export const dictionaries: Record<'us', Dictionary> = {
  us: {
    currency: '$',
    resume: 'resume',
    calendlyLink: 'https://calendly.com/hello-6515/sonicjobs-candidate-feedback-uk-30-minute-meeti-clone',
    jobs: '1M',
    exampleLocation: 'new york',
    country: 'United States',
    countryCodeISO: 'us',
    phonePrefix: '+1',
    zipCode: 'ZIP code',
  },
}
